module.exports = __webpack_public_path__ + "static/media/lody-oxy.abc51914.jpeg";